<div class="sort-toggler"
     fxLayout="column"
     fxLayoutAlign="center end"
     fxLayoutGap.mm-mobile="10px"
     fxLayoutAlign.mm-mobile="center start">
  <div class="sort-toggler__container" fxLayoutAlign="space-around center">
    <app-select (selected)="onSortChange($event)"
                [labelId]="'CATALOG.CATALOG_PAGE.CATALOG_TOOLBAR.SORT_TOGGLER.LABEL' | translate"
                [mmTestTarget]="'sort-toggler'">
      <option *ngFor="let option of sortOptions; let i=index"
              [selected]="(selectedOption$ | async)?.id === option?.id"
              [mmTestTarget]="'sort-option-' + i"
              [value]="option?.id">
        {{ option?.label | translate }}
      </option>
    </app-select>
  </div>
</div>

